export default function initializeSortCountLoaders() {
    // 1) Підключаємо лоадери для селектів
    document.querySelectorAll('.category-container__utils form').forEach((form) => {
        new SelectLoader(form);
    });

    // 2) Скролимо, якщо треба — одразу (бо DOMContentLoaded вже міг відбутись)
    maybeScrollToUtils();

    // 3) На випадок, якщо верстка зміститься після завантаження ресурсів (зображення тощо)
    window.addEventListener('load', () => {
        maybeScrollToUtils();
    }, { once: true });

    // 4) Повернення зі сторінки з BFCache (Safari/Firefox)
    window.addEventListener('pageshow', (e) => {
        if (e.persisted) {
            maybeScrollToUtils();
        }
    });
}

function maybeScrollToUtils() {
    if (!localStorage.getItem('scrollToUtils')) return;

    const utilsBlock = document.querySelector('.category-container__utils');
    if (utilsBlock) {
        // Даємо кадр на рендер перед скролом, щоб позиції були точні
        requestAnimationFrame(() => {
            const rect = utilsBlock.getBoundingClientRect();
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            const offset = 120; // <-- зсув у пікселях
            const top = rect.top + scrollTop - offset;

            window.scrollTo({
                top: top,
                behavior: 'smooth',
            });
        });
    }
    localStorage.removeItem('scrollToUtils');
}

class SelectLoader {
    constructor(form) {
        this.form = form;
        this.select = this.form.querySelector('select');
        if (!this.select) return;

        this.loader = document.createElement('span');
        this.loader.classList.add('select__loader');
        this.loader.innerHTML = `<span class="spinner"></span>`;

        this.select.addEventListener('change', (e) => {
            e.preventDefault();

            // ставимо прапорець перед сабмітом
            localStorage.setItem('scrollToUtils', 'true');

            this.showLoader();

            // Невеличка затримка для UX, як у пагінації
            setTimeout(() => {
                this.form.submit();
            }, 100);
        });
    }

    showLoader() {
        this.select.style.display = 'none';
        this.form.appendChild(this.loader);
    }
}
